import { createAction, props } from '@ngrx/store';
import {
  GoogleAuthLoginSetup,
  LoginCredentialsPayload,
} from '../../../models/auth.model';

export const submitCredentials = createAction(
  '[Login] Submit Credentials',
  props<{ payload: LoginCredentialsPayload }>()
);

export const submitCredentialsSuccess = createAction(
  '[Login] Submit Credentials Success',
  props<{
    username: string;
    sessionToken: string | null;
    loginMethod: string | null;
    password: string;
    nextStep: string | null;
    googleAuthRequired: boolean;
  }>()
);

export const submitCredentialsFailure = createAction(
  '[Login] Submit Credentials Failure',
  props<{ error: string }>()
);

export const verifyOtp = createAction(
  '[Login] Verify OTP',
  props<{ code: string }>()
);

export const verifyOtpSuccess = createAction(
  '[Login] Verify OTP Success',
  props<{
    sessionToken: string | null;
    loginMethod: string | null;
    nextStep: string | null;
    googleAuthRequired: boolean;
    isComplete: boolean;
    accessToken?: string | null;
    refreshToken?: string | null;
  }>()
);

export const verifyOtpFailure = createAction(
  '[Login] Verify OTP Failure',
  props<{ error: string }>()
);

export const verifyGoogle = createAction(
  '[Login] Verify Google',
  props<{ code: string }>()
);

export const verifyGoogleSuccess = createAction(
  '[Login] Verify Google Success',
  props<{
    accessToken: string | null;
    refreshToken: string | null;
  }>()
);

export const verifyGoogleFailure = createAction(
  '[Login] Verify Google Failure',
  props<{ error: string }>()
);

/** Fetch the QR code for a member who enrols Google Authenticator at sign-in. */
export const startGoogleSetup = createAction('[Login] Start Google Setup');

export const startGoogleSetupSuccess = createAction(
  '[Login] Start Google Setup Success',
  props<{ setup: GoogleAuthLoginSetup }>()
);

export const startGoogleSetupFailure = createAction(
  '[Login] Start Google Setup Failure',
  props<{ error: string }>()
);

/**
 * Enter the Google Authenticator step from outside the login screens: a first
 * sign-in whose password setup answered SETUP_2FA (account activation).
 */
export const googleAuthStepEntered = createAction(
  '[Login] Google Auth Step Entered',
  props<{ sessionToken: string; setupRequired: boolean }>()
);

export const resendOtp = createAction('[Login] Resend OTP');

export const resendOtpSuccess = createAction(
  '[Login] Resend OTP Success',
  props<{
    sessionToken: string | null;
    loginMethod: string | null;
    nextStep: string | null;
    googleAuthRequired: boolean;
  }>()
);

export const resendOtpFailure = createAction(
  '[Login] Resend OTP Failure',
  props<{ error: string }>()
);

export const reset = createAction('[Login] Reset');

export const setLoading = createAction(
  '[Login] Set Loading',
  props<{ loading: boolean }>()
);

export const setError = createAction(
  '[Login] Set Error',
  props<{ error: string | null }>()
);

export const clearError = createAction('[Login] Clear Error');

export const backToCredentials = createAction('[Login] Back To Credentials');
